/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Sent_Link_ToInputs */



/**
* | output |
* | --- |
* | "We sent a link to" |
*
* @param {Login_Sent_Link_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_sent_link_to = /** @type {((inputs?: Login_Sent_Link_ToInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Sent_Link_ToInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous avons envoyé un lien à")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hemos enviado un enlace a")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviamos um link para")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbiamo inviato un link a")
	return /** @type {LocalizedString} */ ("We sent a link to")
});